/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioAlertResponseSchema = z.object({
  alertType: z.enum([
    'SCENARIO_ITEM_MODIFIED',
    'ITEM_STORE_SCHEDULE_CHANGES',
    'ITEM_STORE_DEPENDENCY_CHANGES',
    'ITEM_STORE_ITEMS_ADDED',
    'ITEM_STORE_ITEMS_DELETED',
    'TEAM_COMPOSITION_UPDATED',
    'ESTIMATION_EFFORT_UPDATED',
    'ITEMS_UNDER_DONE_ANCESTOR',
    'TEAM_WITHOUT_MEMBERS',
  ]),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  impactedItemCount: z.int(),
  scenarioId: z.int(),
});
